import React from 'react';

// TODO: [添削] Storybook未実装
/** 横に並べる用 */
export const SideBy: React.FC<{ space?: number; style?: React.CSSProperties }> = ({ space = 4, style, children }) => (
  <div style={{ display: 'flex', gap: space, ...(style ?? {}) }}>{children}</div>
);
